<template>
  <div>
    <div class="task container-dropzone">
      <!-- <label> {{ task.label }} </label> -->
      <div id="uploadFile" :class="['w3-right', {'loading': loading}, {'active': dragEnter}]">
        <vue-dropzone
          ref="myVueDropzone"
          id="dropzone"
          :options="dropzoneOptions"
          :showRemoveLink="true"
          @vdropzone-addedfile="uploadFileManually"
        />
      </div>
      <div class="dz-preview dz-file-preview">
        <transition name="fade" mode="out-in">
          <div v-if="!loading" class="dz-details">
            <div class="dz-filename"><span data-dz-name></span></div>
            <div class="dz-size" data-dz-size></div>
          </div>
          <spinner-loading v-else class="taskFileLoading" :size="18" />
        </transition>
      </div>
      <transition-group name="fade" mode="out-in">
        <div v-if="dzError && dzError !== '' && dzErrorShow" class="dz-error-message label error_validate" key="error-msg">
          <span data-dz-errormessage="" v-html="dzError"></span>
          <i class="sherpa-icon icon-cerrar" @click="hideDzError"></i>
        </div>
        <div v-else-if="taskResp && taskResp !== ''" class="label error_validate oky_validate" key="ok-msg">
          <span> {{ taskResp }} </span>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import SpinnerLoading from 'vue-simple-spinner'
import language from '../../language'

export default {
  name: 'definition-task-file',
  components: {
    vueDropzone: vue2Dropzone,
    SpinnerLoading
  },
  props: [
    'task',
    'definition',
    'definitionContentId',
    'repeatableGroupCode',
    'object',
    'taskRefresh',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'callTask'
  ],
  data () {
    return {
      loading: false,
      taskError: false,
      taskResp: '',
      dropzoneOptions: this.getDropzoneOptions(),
      mimeTypes: this.getMimeTypes(),
      dzError: '',
      dzErrorShow: false,
      languageLoaded: true,
      dragEnter: false
    }
  },
  methods: {
    setLanguageLoaded () {
      this.languageLoaded = true
    },
    getCurrentLanguage () {
      var result = null
      if (this.languageSelected) {
        result = this.languageSelected.key
      }
      if (!result) {
        result = this.getLang('isoCode')
      }
      return result
    },
    getDropzoneIcon () {
      var result = ''
      var regExp = this.task.validation.format.regExp

      if (regExp === '.zip') {
        result = 'icon-zip'
      } else if (regExp === '.jpg' || regExp === '.png' || regExp === '.gif') {
        result = 'icon-imagen'
      } else {
        result = 'icon-copy'
      }

      return result
    },
    checkFileExtension (fileType) {
      var result = false
      var fileExtensions = this.task.validation.format.regExp.split(',')
      for (var i = 0; i < this.mimeTypes.length && !result; i++) {
        var mimeType = this.mimeTypes[i]
        for (var k = 0; k < fileExtensions.length && !result; k++) {
          if (mimeType.id === fileExtensions[k]) {
            for (var j = 0; j < mimeType.mimes.length && !result; j++) {
              if (mimeType.mimes[j] === fileType) {
                result = true
              }
            }
          }
        }
      }
      return result
    },
    getFileName (filename) {
      const lastDotIndex = filename.lastIndexOf('.')
      return lastDotIndex !== -1 ? filename.substring(0, lastDotIndex) : 'filename'
    },
    getFileExtension (filename) {
      const lastDotIndex = filename.lastIndexOf('.')
      return lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : 'extension'
    },
    getDropzoneOptions () {
      var self = this

      var taskUrl = this.type.domainEndpoint
      if (this.type.taskDomainEndpoint) {
        taskUrl += this.type.taskDomainEndpoint
      }
      taskUrl += this.task.type.endpoint

      return {
        timeout: 30 * 60 * 1000,
        url: taskUrl,
        maxFilesize: this.task.validation.format.lengthMax / (1024 * 1024), // bytes / (1024 * 1024) --> MB
        acceptedFiles: this.task.validation.format.regExp,
        uploadMultiple: false,
        clickable: true,
        createImageThumbnails: false,
        autoProcessQueue: false,
        dictFallbackMessage: this.getLang('dictFallbackMessage'),
        dictFallbackText: this.getLang('dictFallbackText'),
        dictFileTooBig: this.getLang('dictFileTooBig'),
        dictInvalidFileType: this.getLang('dictInvalidFileType'),
        dictResponseError: this.getLang('dictResponseError'),
        dictCancelUpload: this.getLang('dictCancelUpload'),
        dictCancelUploadConfirmation: this.getLang('dictCancelUploadConfirmation'),
        dictRemoveFile: this.getLang('dictRemoveFile'),
        dictRemoveFileConfirmation: null,
        dictMaxFilesExceeded: this.getLang('dictMaxFilesExceeded'),
        dictDefaultMessage: '<p><i class="sherpa-icon ' + this.getDropzoneIcon() + '" style="position:absolute;top:16px;left:0;right:0;text-align:center;font-size:2.1em;color:#ffbf28;"></i><br><span style="font-style:italic;position:absolute;top:60px;left:0;font-size:12px;color:#ffbf28;text-align:center;font-weight:500;padding:3px;width:100%;">' + this.task.label + '</span></p>',
        accept: function (file, done) {
          if (self.checkFileExtension(file.type)) {
            done()
          } else {
            self.dzError = self.getLang('errorRegExp')
            self.dzErrorShow = true
            done(self.getLang('errorRegExp'))
          }
        },
        init: function () {
          this.on('addedfile', function (file) {
            if (self.checkFileExtension(file.type)) {
              self.dzError = null
              self.dzErrorShow = false
              self.loading = true
              self.taskResp = null
              self.uploadFileManually(file)
            } else {
              self.removeFile(file) // Remove the file if it is not valid
            }
          })
          this.on('drop', function (file) {
            self.dzError = null
            self.dzErrorShow = false
            self.loading = true
            self.taskResp = null
          })
          this.on('error', function (file, message) {
            self.dzError = message
            self.dzErrorShow = true
            self.loading = false
            this.removeFile(file)
          })
          this.on('dragover', function (event) {
            self.dragEnter = true
          })
          this.on('dragleave', function (event) {
            self.dragEnter = false
          })
        }
      }
    },
    async uploadFileManually (file) {
      const formData = new FormData()
      formData.append('files', file)
      formData.set('id', this.definitionContentId)
      formData.set('code', this.repeatableGroupCode)
      formData.set('lang', this.getCurrentLanguage())

      try {
        const response = await fetch(this.dropzoneOptions.url, {
          method: 'POST',
          headers: {
            'authorization': this.authorization
          },
          body: formData
        })

        const contentType = response.headers.get('Content-Type')

        // tsres
        if (contentType && contentType.includes('application/json')) {
          const jsonResponse = await response.json()
          if (jsonResponse.requestResult) {
            this.taskResp = jsonResponse.requestResultSuccess
            if (jsonResponse.requestObject) {
              this.$emit('refreshDefinition', jsonResponse.requestObject[0])
            }
          } else {
            if (jsonResponse.requestResultError.requestErrorMsg) {
              this.dzError = jsonResponse.requestResultError.requestErrorMsg.replace(/(?:\r\n|\r|\n)/g, '<br />')
            } else {
              this.dzError = this.getLang('error500header')
            }
            this.dzErrorShow = true
          }

        // file
        } else {
          const blobResponse = await response.blob()
          var fileDownload = require('js-file-download')
          fileDownload(blobResponse, this.getFileName(file.name) + '.validated.' + this.getFileExtension(file.name))
          this.taskResp = this.getLang('fileDownloaded')
        }

        this.loading = false
      } catch (error) {
        console.error('Error uploading file:', error)
      }
    },
    getMimeTypes () {
      return [
        {
          id: '.zip',
          mimes: [
            'application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'
          ]
        },
        {
          id: '.rar',
          mimes: [
            'application/x-rar-compressed', 'application/octet-stream'
          ]
        },
        {
          id: '.jpg',
          mimes: [
            'image/jpeg', 'image/jpg'
          ]
        },
        {
          id: '.png',
          mimes: [
            'image/png'
          ]
        },
        {
          id: '.gif',
          mimes: [
            'image/gif'
          ]
        },
        {
          id: '.docx',
          mimes: [
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ]
        },
        {
          id: '.xls',
          mimes: [
            'application/vnd.ms-excel'
          ]
        },
        {
          id: '.xlsx',
          mimes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ]
        },
        {
          id: '.xlsm',
          mimes: [
            'application/vnd.ms-excel.sheet.macroEnabled.12'
          ]
        },
        {
          id: '.xlsb',
          mimes: [
            'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
          ]
        },
        {
          id: '.pptx',
          mimes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          ]
        },
        {
          id: '.pdf',
          mimes: [
            'application/pdf'
          ]
        }
      ]
    },
    getLang (key) {
      return language(this.language, key)
    },
    hideDzError () {
      this.dzErrorShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
#uploadFile {
  position: relative;
  width: 100%;
  height: 100px;
  background-color: #fffcf5;
  border-radius: 3px;
  border-left: 1px dashed #ffbf28;
  border-right: 1px dashed #ffbf28;
  border-bottom: 1px dashed #ffbf28;

  #dropzone {
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
#uploadFile:hover,
#uploadFile.active {
  border-left: 1px solid #ffbf28;
  border-right: 1px solid #ffbf28;
  border-bottom: 1px solid #ffbf28;
  opacity: 0.6;
}
.error_validate.oky_validate {
  color: green !important;
  padding-top: 5px;
  text-align: center;
  position: static;
}
</style>

<style lang="scss">
/* .dropzone .dz-preview .dz-error-message, */
.dropzone .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark,
.dropzone .dz-preview .dz-progress,
.dropzone .dz-preview .dz-image,
.dropzone .dz-preview .dz-size {
  display: none !important;
}

.dropzone .dz-preview .dz-details,
.dz-preview.dz-file-preview {
  position: relative;

  .dz-filename,
  .dz-size {
    font-stretch: normal;
    line-height: 1.1;
    letter-spacing: normal;
    position: absolute;
    top: 60px;
    font-style: italic;
    font-weight: 400;
    padding: 0;
    font-size: 0.9em;
    margin-bottom: 2px;
    color: green;
    width: auto;
  }

  .taskFileLoading {
    position: relative;
    left: 0;
    right: 0;
    top: 40px;
    bottom: 0;
  }

  .dz-filename {
    top: 80px;
    display: none;
  }
}

.image {
  .dropzone .dz-preview .dz-details,
  .dz-preview.dz-file-preview {
    .taskFileLoading {
      top: 38px !important;
    }
  }
}

.loading {
  .dz-message {
    display: none;
  }
}

.label.error_validate.dz-error-message {
  position: static;
  padding: 15px 10px 10px 10px;
  border-radius: 4px;
  border: 1px dotted #999;
  z-index: 100000;
  background-color: #fff;
  cursor: default;
  min-height: 50px;
  overflow-y: auto;
  width: 100%;

  .icon-cerrar {
    color: #ff7643;
    right: 22px;
    bottom: 127px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    font-size: 12px;
    margin-right: 0;
  }
  .icon-cerrar:hover {
    color: #ffcc00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/task/taskFile.vue